export default "__VITE_ASSET__CApGNWf9__"